import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, IconButton, TableHead, TableRow, TableCell } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import * as R from 'ramda'

import Input from 'components/fulcrum/input/Input'

import styles from './styles.scss'

import { 
    CONFIG_TABLE_ATTR,
    POWER_ON_OFF
} from './constants'

import T from 'i18n-react' 


class ConfigTable extends Component {

  onEdit = (idx, attr, val) => {
    if (val !== '') {
        val = parseInt(val)
        if (!val) return
      }
      this.props.onEdit(idx, attr, val)
  }

  getTableHead = () => (
      <TableHead>
          {CONFIG_TABLE_ATTR.map((attr) => {
              const key = `missionProfileHeader${attr}`
              const label = T.translate(`${POWER_ON_OFF}.${attr}`)
              return <TableCell key={key}>{label}</TableCell>
          })}
      </TableHead>
  )

  getTableRowCells = (row, idx, key) => 
    CONFIG_TABLE_ATTR.map((attr) => {
        const cellKey = `${key}${attr}`
        const onChange = this.onEdit.bind(this, idx, attr)
        const value = !row[attr] && row[attr] !== 0 ? '' : row[attr]
        return (
            <TableCell key={cellKey}>
                <Input type='number' 
                    value={value}
                    onChange={onChange}
                />
            </TableCell>
    )})

  getTableRowCellsDel = (idx) => {
    const onRemove = this.props.onRemove.bind(this, idx)
    return (
        <TableCell styleName="deleteBtn" theme={styles}>
            <IconButton icon='delete' onClick={onRemove} primary />
        </TableCell>
    )
  }

  getTableRows = () => {
    const {
        values,
        mpIndex
    } = this.props

    if (values == null) return

    return values.map((row, idx) => {
        const key = `misionProfile${mpIndex}powerOn${idx}`
        return (
        <TableRow key={key}>
            {this.getTableRowCells(row, idx, key)}
            {this.getTableRowCellsDel(idx)}
        </TableRow>)})
  }

  getAddButton = () => {
      const {
          onAdd,
          addBtnText
      } = this.props
      
      return (
        <div styleName = 'addConfigWrapper'>            
            <a styleName='addConfig' onClick={onAdd}>{addBtnText}</a>
        </div>
      )
  }
    
  render() {

    const { title } = this.props

    return (
        <div styleName='configTable'>
            <div><span>{title}</span></div>
            <div styleName='configTableContent'>
                <Table theme={styles} selectable={false}>
                    {this.getTableHead()}
                    {this.getTableRows()}
                </Table>
                {this.getAddButton()}
            </div>
        </div>
    )
  }
}

export default CSSModules(ConfigTable, styles)
